module.exports = __webpack_public_path__ + "static/media/isimicinlogo_white.71298393.png";